import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import styleShino from "styled-components";
import {styled} from "@mui/system";
import Button from "@mui/material/Button";
import BigNumber from "bignumber.js";
import {useEthers} from "@usedapp/core";
import Modal from "./Modal";
import CountDown from "./CountDown";
import styles from "./functional.module.scss";
import {
  harvestSelectedContract,
  emergencyWithdrawSelectedContract,
  withdrawSelectedContract,
  updateSelectedPool,
  setIsEmergencyWithdrawLoading,
  setIsWithdrawLoading,
  setIsHarvestLoading,
} from "../../../store/stakingStore";

const changePoolData = [
  {
    id: 1,
    value: 0,
    name: "one mounth busd",
  },
  {
    id: 1,
    value: 1,
    name: "two mounth busd",
  },
  {
    id: 1,
    value: 2,
    name: "three mounth busd",
  },
];

function MultiFunctionalCard({stackingPool, stakedAmount}) {
  const [pendingReward, setPendingReward] = useState(null);
  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState(0);
  const [withdrawableTime, setWithdrawableTime] = useState(null);
  console.log("withdrawableTime", withdrawableTime);

  const {account, library} = useEthers();
  const dispatch = useDispatch();
  const {contract, isEmergencyWithdrawLoadingObj, isWithdrawLoadingObj} =
    useSelector((state) => state.stakingSlice);
  const stakedTokenAmount = new BigNumber(stakedAmount)
    .dividedBy(Math.pow(10, 9))
    .toNumber()
    .toLocaleString("en", {useGrouping: true});

  const handleDepositAmount = (event) => {
    setAmount(event.target.value);
  };
  const handleEmergencyWithdraw = () => {
    const emergencyWithdrawObj = {
      selectedPoolId: stackingPool?.id,
      isFixed: stackingPool?.isFixed,
      provider: library,
    };

    dispatch(emergencyWithdrawSelectedContract(emergencyWithdrawObj));
    const selectedObj = {
      id: stackingPool?.id,
      isFixed: stackingPool?.isFixed,
    };

    dispatch(setIsEmergencyWithdrawLoading(selectedObj));
  };

  const handleFixedWithdraw = () => {
    const withdrawObj = {
      selectedPoolId: stackingPool?.id,
      withdrawAmount: null,
      isFixed: stackingPool?.isFixed,
      provider: library
    };
    if (stackingPool?.isFixed) {
      dispatch(withdrawSelectedContract(withdrawObj));
    } else {
      setOpen(true);
    }
    const selectedObj = {
      id: stackingPool?.id,
      isFixed: stackingPool?.isFixed,
    };

    dispatch(setIsWithdrawLoading(selectedObj));
  };

  const handleWithdraw = () => {
    const withdrawObj = {
      selectedPoolId: stackingPool?.id,
      withdrawAmount: new BigNumber(amount)
        .multipliedBy(Math.pow(10, 9))
        .toNumber(),
      isFixed: stackingPool?.isFixed,
      provider: library,
    };
    dispatch(withdrawSelectedContract(withdrawObj)).catch((err) =>
      console.log(err)
    );
    const selectedObj = {
      id: stackingPool?.id,
      isFixed: stackingPool?.isFixed,
    };
    dispatch(setIsWithdrawLoading(selectedObj));
  };
  const harvestSelectedPool = () => {
    dispatch(harvestSelectedContract(stackingPool?.id));
    const selectedObj = {
      id: stackingPool?.id,
      isFixed: stackingPool?.isFixed,
      provider :library
    };
    dispatch(setIsHarvestLoading(selectedObj));
  };

  const getPendingReward = async () => {
    if (stackingPool?.isFixed) {
      const reward = await contract.pendingReward(stackingPool?.id, account);
      setPendingReward(reward.toString());
    } else {
      const reward = await contract.pendingReward(stackingPool?.id, account);

      setPendingReward(reward.toString());
    }
  };

  useEffect(() => {
    const canWithdrawTime = async () => {
      try {
        const withdrawTime = await contract.withdrawCountdown(
          stackingPool?.id,
          account
        );
        setWithdrawableTime(withdrawTime.toString() * 1000);
        return true;
      } catch (e) {
        console.log(e);
      }
    };
    canWithdrawTime();
  }, [account, contract, stackingPool?.id]);
  console.log("withdrawableTime", withdrawableTime);

  useEffect(() => {
    getPendingReward();
  }, []);
  useEffect(() => {});
  const [isVisible, setIsVisible] = useState(false);
  const [isVisibleWith, setIsVisibleWith] = useState(false);
  console.log("isWithdrawLoadingObj", isWithdrawLoadingObj);
  return (
    <>
      <CardContainer className={styles.container}>
        <div className={styles.inlineContainer}>
          <div className={styles.topWrapper}>
            <div>
              <CardText>Pool Rate: {stackingPool?.APR?.toString() / 100}%</CardText>
            </div>
            <div className={styles.reward}>
              <CardText>Pending Reward:</CardText>
              <CardText>
                {pendingReward
                  ? new BigNumber(pendingReward.toString())
                      .dividedBy(Math.pow(10, 9))
                      .toNumber()
                      .toLocaleString("en", {useGrouping: true})
                  : "0"}{" "}
                {stackingPool.isFixed ? "$SHINO" : "BUSD"}
              </CardText>
            </div>
            <div className={styles.reward}>
              <CardText>Staked:</CardText>
              <CardText>
                {stakedTokenAmount} {stackingPool.isFixed ? "$SHINO" : "BUSD"}
              </CardText>
            </div>
          </div>
          {!stackingPool?.isFixed && (
            <ContainerSpaceBetween>
              <DepositButton variant="contained" onClick={harvestSelectedPool}>
                Harvest
              </DepositButton>
            </ContainerSpaceBetween>
          )}
          <FlexCenterContainer>
            <FlexContainer>
              <ButtonWithdraw onClick={handleWithdraw} variant="contained">
                {isWithdrawLoadingObj?.id === stackingPool?.id &&
                isWithdrawLoadingObj?.isFixed === stackingPool?.isFixed &&
                isWithdrawLoadingObj?.withdrawLoading
                  ? "Processing..."
                  : "Withdraw"}
              </ButtonWithdraw>
              <ButtonEmergency
                onClick={handleEmergencyWithdraw}
                variant="contained"
                color="error"
              >
                {isEmergencyWithdrawLoadingObj?.id === stackingPool?.id &&
                isEmergencyWithdrawLoadingObj?.isFixed ===
                  stackingPool?.isFixed &&
                isEmergencyWithdrawLoadingObj.emergencyWithdrawLoading
                  ? "Processing..."
                  : "Emergency"}
              </ButtonEmergency>
            </FlexContainer>
            {isVisible && (
              <div className={styles.alert}>
                Are you sure about the emergency shot?
                <div className={styles.buttonWrapper}>
                  <button className={styles.noButton}>No</button>
                  <button onClick={handleEmergencyWithdraw}>Yes</button>
                </div>
              </div>
            )}
            {isVisibleWith && (
              <Modal
                amount={amount}
                setAmount={setAmount}
                handleDepositAmount={handleDepositAmount}
                handleWithdraw={handleWithdraw}
              />
            )}
            <ChangePool>
              <CountDown withdrawableTime={withdrawableTime} />
            </ChangePool>
          </FlexCenterContainer>
        </div>
      </CardContainer>
    </>
  );
}

export default MultiFunctionalCard;

const CardContainer = styleShino.div`
  padding: 10px !important;
`;

const CardText = styleShino.span`
  color: #fdfdfd;
  font-size: 1rem;
  margin-top: 5px;
`;

const ChangePool = styleShino.div`
  button {
    background-color: #00000073;
    border: 1px solid white;
    &:hover {
      background: none;
    }
  }
`;

const ContainerSpaceBetween = styleShino.div`
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  flex-direction: column;
  button {
    width: 100%;
    border-radius: 1.5rem;
    background: none;
    border: 2px solid #3851d6;
    &:hover {
      background: none;
    }
  }
`;
const FlexCenterContainer = styleShino.div`
  padding: 10px;
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const FlexContainer = styleShino.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

const DepositButton = styled(Button)`
  width: 40%;
  margin-top: 5px;
  padding: 12px;
  font-size: 0.8rem;
`;
const ButtonWithdraw = styled(Button)`
  margin-top: 5px;
  width: 100%;
  box-shadow: 0 0 10px rgb(41 249 23 / 50%);
  font-size: 0.8rem;
  border: 2px solid rgba(41, 249, 23, 1);
  border-radius: 1.5rem;
  background: none;
  &:hover {
    background: none;
  }
`;

const ButtonEmergency = styled(Button)`
  border-radius: 1.5rem;
  margin-top: 5px;
  width: 100%;
  font-size: 0.8rem;
  background: rgba(221, 25, 39, 0.2);
  color: #fff;
  border: 2px solid rgba(221, 25, 39, 1);
  box-shadow: 0 0 10px rgb(221 25 39 / 50%);
  &:hover {
    background: none;
  }
`;
